import React, {Component} from 'react';
import {Editor} from '../editor-components';

export default class UnassignedDashboard extends Component {
  render() {
    return (
      <Editor>
        <h1>Unassigned Role</h1>
        <div className="info-panel">
          <p>
            At this time, you do not have an
            assigned role in the Vexpo Admin Platform.
            If you belive you have reached this page in error,
            contact Vexpo Shows to correct the issue.
          </p>
        </div>
      </Editor>
    )
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/unassigned-dashboard.js